import { useForm, FormProvider } from "react-hook-form";
import { FormattedMessage, useIntl } from "react-intl";
import { Col, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

import Dialog from "components/organisms/Dialog/Dialog";
import Button from "components/atoms/Button/Button";
import { undoDeclineRequest } from "api";
import errorToast from "helpers/errorToast";
import testIds from "constants/testIds";

interface IReopenDialogProps {
  isOpen: boolean;
  close: () => void;
  getQuoteRequest: Function;
}

function ReopenDialog({ isOpen, close, getQuoteRequest }: IReopenDialogProps) {
  const intl = useIntl();
  const methods = useForm();
  const { handleSubmit } = methods;
  const { id } = useParams();

  const handleUndoDeclineRequest = () => {
    undoDeclineRequest(id)
      .then(() => {
        toast(
          intl.formatMessage({
            id: "quote.undoDeclineSuccessMsg",
            defaultMessage: "Quote request reopened successfully",
          }),
          { type: "success" },
        );
        getQuoteRequest();
        close();
      })
      .catch((error) => errorToast(error));
  };

  return (
    <Dialog
      size="sm"
      title={intl.formatMessage({
        id: "quote.reopenQuotes",
        defaultMessage: "Reopen Quotes",
      })}
      show={isOpen}
      onHide={close}
    >
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(handleUndoDeclineRequest)}>
          <div style={{ maxWidth: 400 }}>
            <p className="font-b1">
              <FormattedMessage
                id="quote.isUndo"
                defaultMessage="Are you sure you want to undo the declining of this quote request"
              />
            </p>
            <p className="text-secondary font-b1 mt-4">
              <FormattedMessage
                id="quote.reopenQuoteRequest"
                defaultMessage="Use this to undo the decline quote request.This will allow you to submit a quote for this request"
              />
            </p>
          </div>
          <Row className="mt-5">
            <Col lg={12} className="d-flex justify-content-between">
              <Button
                variant="outline-primary"
                label={intl.formatMessage({
                  id: "general.cancel",
                  defaultMessage: "Cancel",
                })}
                size="lg"
                onClick={close}
                data-testid={testIds.SHIPMENT_DASHBOARD_UNDECLINE_MODAL_CLOSE_BUTTON}
              />
              <Button
                variant="primary"
                type="submit"
                size="lg"
                label={intl.formatMessage({ id: "general.yesUndo", defaultMessage: "Yes, Undo" })}
                data-testid={testIds.SHIPMENT_DASHBOARD_UNDECLINE_UNDO_BUTTON}
              />
            </Col>
          </Row>
        </form>
      </FormProvider>
    </Dialog>
  );
}

export default ReopenDialog;
